import { Provider } from '@angular/core';

export const MOCK_PROVIDERS: Provider[] = [];
